import * as React from 'react';
import { cn } from '@/lib/cn';

interface EmptyStateProps {
  variant?: 'blank' | 'success' | 'error' | 'pending';
  title: React.ReactNode;
  body?: React.ReactNode;
  action?: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}

const VARIANT_BG = {
  blank: 'bg-[color:var(--color-surface-2)]',
  success: 'bg-[color:var(--color-success-soft)]',
  error: 'bg-[color:var(--color-danger-soft)]',
  pending: 'bg-[color:var(--color-surface-2)]',
} as const;

export function EmptyState({
  variant = 'blank',
  title,
  body,
  action,
  icon,
  className,
}: EmptyStateProps) {
  return (
    <div
      role={variant === 'error' ? 'alert' : 'status'}
      className={cn(
        'mx-auto flex max-w-md flex-col items-center gap-3 rounded-[var(--radius-lg)] border border-[color:var(--color-border)] p-10 text-center',
        VARIANT_BG[variant],
        className
      )}
    >
      {icon ? <div aria-hidden className="text-[color:var(--color-fg-muted)]">{icon}</div> : null}
      <h2 className="text-base font-semibold text-[color:var(--color-fg)]">{title}</h2>
      {body ? <p className="text-sm text-[color:var(--color-fg-muted)]">{body}</p> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
